var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _polygon2, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnepay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 559.93 161.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d559f;}.cls-2{fill:#00a7d7;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo_OnePay") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.53,45.85c21.48,0,39,18.6,39,41.46S82,128.77,60.53,128.77s-38.95-18.6-38.95-41.46,17.48-41.46,39-41.46m0-18.08c-31.49,0-57,26.66-57,59.54s25.54,59.55,57,59.55,57-26.66,57-59.55S92,27.77,60.53,27.77Z",
    transform: "translate(-3.5 -27.77)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.45,104v.21h0Z",
    transform: "translate(-3.5 -27.77)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.73,96.34c-3.58-19.76-20.32-34.76-40.38-34.76-22.67,0-41.11,19.14-41.11,42.67s18.44,42.68,41.11,42.68a41.2,41.2,0,0,0,36.44-22.85l-16.43-3.91c-4.74,6.26-11.32,10.69-20,10.69-11.14,0-21.78-8.43-23.84-19.7l64.41,0a55.19,55.19,0,0,0,.39-6.25A61.18,61.18,0,0,0,292.73,96.34Zm-64.27,0c3.19-10.79,12.69-18.64,23.89-18.64s20.71,7.87,23.89,18.68Z",
    transform: "translate(-3.5 -27.77)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.72,27.77H306.46V146.85h19.42V101.77h26.84a37,37,0,0,0,0-74Zm0,56.59H325.88V45.18h26.84a19.59,19.59,0,0,1,0,39.18Z",
    transform: "translate(-3.5 -27.77)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M452.79,61.87V72.82a31.91,31.91,0,0,0-23.52-11c-22.39,0-40.55,19.06-40.55,42.57s18.16,42.57,40.55,42.57c8.77,0,17.83-4.34,23.52-10.33v10.25h17.42v-85Zm-23.52,67.64c-12.76,0-23.13-11.28-23.13-25.15s10.37-25.15,23.13-25.15,24.23,9.05,24.23,25.15S442,129.51,429.27,129.51Z",
    transform: "translate(-3.5 -27.77)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "511.25 75.41 493.66 34.02 474.74 34.02 501.35 96.64 511.25 75.41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "527.87 34.02 533.64 47.61 515.75 85.98 515.74 85.98 505.84 107.21 505.85 107.21 480.48 161.62 500.43 161.62 559.93 34.02 527.87 34.02"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.06,61.3c-12.94,0-21.37,5.24-26.48,10V61.79H126.16v85.07h17.42V100.11c0-10.3,7.25-21.39,23.18-21.39,17.1,0,19,15.06,19,21.53v46.61h17.41V98.08C203.12,78.69,191.51,61.3,170.06,61.3Z",
    transform: "translate(-3.5 -27.77)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnepay);
export default __webpack_public_path__ + "static/media/onepay.c0febe1cbc5d8093fd1e26e5df28a404.svg";
export { ForwardRef as ReactComponent };